import { useDispatch, useSelector } from "react-redux";

import { CareersForm } from "./CareersForm";
import { ErrorBanner } from "../../components/banner";
import { Section } from "../../components/section";
import { createJob } from "../../redux/careers";
import { useNavigate } from "react-router-dom";

export const CareersCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { error } = useSelector((state) => state.careers);

  const onFormSubmit = (values) => {
    if (window.confirm("Are you sure you want to post this job?")) {
      return dispatch(createJob(values))
        .unwrap()
        .then(() => {
          navigate("/careers");
        })
        .catch((err) => {
          console.error("Failed to create job:", err);
        });
    }
  };

  return (
    <Section>
      {error && <ErrorBanner text={error} />}
      <CareersForm onFormSubmit={onFormSubmit} />
    </Section>
  );
};
